import { Outlet, Navigate } from "react-router-dom";
import { Suspense } from "react";

import AuthLayout from "@/components/layout/auth";
import { useAuthData } from "@/store/hooks";
import SplashLoader from "@/components/ui/splashLoader";

import { PROTECTED_PATHS } from "./protectedRoutes";
import { isSigningCallbackPath } from "./isSigningCallbackPath";

const PublicRoute: React.FC = () => {
  const { isAuthorized } = useAuthData();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") ?? "";
  const pathname = window.location.pathname;

  // Docusign signing callback pages load inside the signing modal's iframe and
  // must render even when the user is authenticated — otherwise an authed user
  // hits the redirect below and the iframe shows the dashboard instead of the
  // signing result.
  if (isSigningCallbackPath(pathname)) {
    return (
      <Suspense fallback={<SplashLoader />}>
        <Outlet />
      </Suspense>
    );
  }

  return !isAuthorized || token ? (
    <Suspense fallback={<SplashLoader />}>
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    </Suspense>
  ) : (
    <Navigate to={PROTECTED_PATHS.DASHBOARD} />
  );
};

export default PublicRoute;
